import { ProfessionIcon } from './profession-icon';

export const IconCaterer = () => (
  <ProfessionIcon bg="#FFF8E1">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <path d="M3 18h18v2H3v-2z" stroke="#FF9800" strokeWidth="1.8" />
      <path
        d="M5 18c0-4 2.69-7.27 7-7.87C16.31 10.73 19 14 19 18"
        stroke="#FF9800"
        strokeWidth="1.8"
      />
      <path
        d="M12 6a2 2 0 100-4 2 2 0 000 4z"
        stroke="#FF9800"
        strokeWidth="1.8"
      />
      <path
        d="M12 6v4"
        stroke="#FF9800"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  </ProfessionIcon>
);
